export default {
    productIsNla: function (organisations, organisationId) {
        for (let organisation of organisations) {
            if (organisation.organisation_id !== parseInt(organisationId)) {
                continue
            }

            if (organisation.dchain_valid_date === null) {
                continue
            }

            if (organisation.dchain_spec_status !== 'NL') {
                continue
            }

            const currentDate = new Date()
            const expireDate = new Date(organisation.dchain_valid_date)

            if (currentDate >= expireDate) {
                return true;
            }
        }

        return false;
    }
}
